import { Flow_0_0_2, getSelectedItemOne, getFullItemOne, getAllInfo, getData } from '@flexus/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { CollapseActionPanel, setActionPanelItems } from '../../../../app-shell-features';
import { take, filter, skipWhile, first, map, switchMap, pluck, tap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { environment } from 'apps/studio/src/environments/environment';
import { isNil } from '@flexus/utilities';

export const BET_55: Flow_0_0_2 = {
	id: '55',
	name: 'finalise_claim',
	itemType: 'flow',
	header: {
		title: (store, bf) => {
			return store.select(getFullItemOne).pipe(
				filter(x => !!x),
				skipWhile((itemOne: any) => {
					return itemOne === null || itemOne === undefined;
				}),
				first(itemOne => itemOne !== null || itemOne !== undefined),
				map((itemOne: any) => {
					if (itemOne) {
						return `Finalise Claim : ${itemOne.mid} - ${itemOne.applicant?.surname}`;
					} else {
						return 'Finalise Claim';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	actionPanel: instance => setActionPanelItems(instance, ['notes', 'documents', 'time-stamp', 'claim-card', 'call-logs'], { filesFunctionName: 'getAllClaimFiles' }),
	onStateInit: inst => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	onStateDestroy: inst => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	instructions: {
		editRoles: {
			0: 'Finalise Claim'
		},
		viewRoles: {
			0: '--'
		}
	},
	events: {},
	fetchLevel1And2: true,
	serverCalls: {
		canCloseClaim: {
			serviceVariable: 'betService',
			directCall: (http, store, _s, bf, _c, modal) => {
				return store.select(getSelectedItemOne).pipe(
					skipWhile(x => !x),
					take(1),
					switchMap(claim =>
						http
							.post(`${environment.api_url}v1/claim_action/can_finalise_claim`, {
								claim_id: claim?.id
							})
							.pipe(
								skipWhile(x => !x),
								take(1),
								tap((res: { payload: any; success: boolean; reason: Array<any> }) => {
									if (!res?.success) {
										modal.openModalDirectly(instance => {
											instance.type = 'warning';
											instance.message = `You can not finalise claim reason : ${res?.payload?.descriptions?.toString()}`;
											instance.navButtons = [
												{
													text: 'Close',
													linkType: 'close',
													color: 'alert'
												}
											];
										});
									} else {
										bf.bigForm.get('reasons_provided')?.setValue(true);
									}
								})
							)
					)
				);
			},
			errorMessage: 'Claim can not be closed',
			ignoreFalseError: true
		},
		claimAppointments: {
			serviceVariable: 'betService',
			functionName: 'getClaimAppointments',
			errorMessage: 'No claim appointments could be found!'
		},
		paymentsExist: {
			errorMessage: `Payments don't exist`,
			directCall: (http, store, sq, bf) => {
				return store
					.select(getData)
					.pipe(
						pluck('claimAppointments', 'payload', 'xml'),
						skipWhile(x => !x),
						take(1),
						map(pay => pay as any)
					)
					.pipe(
						switchMap(pay => {
							const payments = pay.payments;
							console.log('Payments', payments);
							bf.addControl('payments_exist', new UntypedFormControl(null));
							bf.addControl('number_of_payments', new UntypedFormControl(null));
							if (isNil(payments) || Array.isArray(payments)) {
								bf.bigForm.get('payments_exist')?.setValue(false);
								bf.bigForm.get('number_of_payments')?.setValue(0);
							} else {
								bf.bigForm.get('payments_exist')?.setValue(true);
								bf.bigForm.get('number_of_payments')?.setValue(payments['item']?.length);
								console.log(`THIS LOOOONG`, payments['item']?.length);
							}
							return of(payments);
						})
					);
			}
		}
	},
	startNode: 'CloseClaim',
	nodes: {
		CloseClaim: {
			mockContextData: {},
			checkValidityForFields: ['reasons_provided'],
			initFormFields: (bf, item, instance, storeQuery, store) => {
				bf.addControl('new_state', new UntypedFormControl(7));
				bf.addControl('maven_claim_state', new UntypedFormControl(null));
				bf.addControl('final_claim_outcome', new UntypedFormControl(null));
				bf.addControl('reasons_provided', new UntypedFormControl(false, [Validators.requiredTrue]));

				store
					.select(getData)
					.pipe(
						pluck('canCloseClaim'),
						skipWhile(canCloseClaim => !canCloseClaim),
						take(1)
					)
					.subscribe(closeClaim => {
						bf.bigForm.patchValue({ maven_claim_state: closeClaim?.payload?.maven_claim_state });
						bf.bigForm.patchValue({ final_claim_outcome: closeClaim?.payload?.final_claim_outcome });
					});
			},
			inputs: {
				title: 'Close the Claim',
				subtitle: 'Confirm that all work was done and close the claim.',
				summaryItems: [
					{ title: 'Final claim outcome', formControlName: 'final_claim_outcome' },
					{ title: 'Underwritter', value: 'BETTERSURE' }
				]
			},
			component: 'CloseClaimGeneralComponent',
			serverCalls: {},
			navs: [
				{
					text: 'Finalise',
					nextNode: 'SubmissionSuccess',
					color: 'primary',
					optIntoValidation: true,
					serverFirst: true,
					serverCalls: {
						response: {
							serviceVariable: 'betService',
							ignoreFalseError: true,
							errorMessage: 'Claim could not be closed',
							directCall: (http, store, sq, bf) => {
								return store.select(getFullItemOne).pipe(
									skipWhile(x => !x),
									take(1),
									map(res => res as any),
									switchMap(res => {
										const mavenstate: number = bf.bigForm.get('maven_claim_state')?.value;
										const claim_id: any = res?.id;
										switch (mavenstate) {
											case 0: // ---------------------------- Cancelled (4)----------------------------
											case 1: // ---------------------------- Cancelled - with Excess (13) ----------------------------
												const reason = '4';
												const canceledData = {
													claim_id: claim_id,
													reason: reason
												};
												return http.post(`${environment.api_url}v1/claim_action/cancel_claim/`, canceledData);
											case 2: // ---------------------------- Finalise claim ----------------------------
												const data = {
													claim_id: claim_id
												};
												return http.post(`${environment.api_url}v1/claim_action/finalise_claim/`, data);
											case 3: // ---------------------------- Finalise Repudiation ----------------------------
												const repData = {
													claim_id: claim_id,
													repudiation_type: res?.office_use.repudiation ? res?.office_use.repudiation.repudiation_type : '',
													repudiation_reason: 1,
													letter_key: res?.office_use.repudiation ? res?.office_use.repudiation.repudiation_letter : '',
													repudiation_sub_reason: 1,
													diagnosis: '--',
													email: res?.office_use.repudiation ? res?.office_use.repudiation.emailaddress : '',
													final: 'Y',
													sendletter: 'N',
													_optionalState: 7
												};
												return http.post(`${environment.api_url}v1/claim_action/finalise_repudiation/`, repData);
										}
									})
								);
							}
						}
					}
				},
				{
					text: 'View Payments',
					linkType: 'portal',
					portalData: {
						type: 'modal',
						paramFunc: (instance, store, bf) => {
							if (bf.bigForm.get('payments_exist')?.value === false) {
								(instance.type = 'info'), instance.setMessage(['There are no payments associated with this claim']);
								instance.navButtons = [
									{
										text: 'OK',
										color: 'default',
										linkType: 'close'
										// nextNode: 'CloseClaim'
									}
								];
							} else if (bf.bigForm.get('payments_exist')?.value === true) {
								instance.type = 'info';
								if (bf.bigForm.get('number_of_payments')?.value === 1) {
									instance.setMessage([bf.bigForm.get('number_of_payments')?.value + ` Payment has been made on this claim`, `Click 'View Payments' to proceed`]);
								} else {
									instance.setMessage([bf.bigForm.get('number_of_payments')?.value + ` Payments have been made on this claim`, `Click 'View Payments' to proceed`]);
								}
								instance.navButtons = [
									{
										text: 'No thanks!',
										color: 'default',
										linkType: 'close'
									},
									{
										text: 'View Payments',
										color: 'default',
										linkType: 'nextNode',
										nextNode: 'ViewPayments'
									}
								];
							}
						}
					},
					// nextNode: 'Decision',
					location: 'center',
					color: 'secondary'
				}
			]
		},
		ViewPayments: {
			serverCalls: {},
			component: 'ViewPaymentsComponent',
			initFormFields: () => {}
		},
		SubmissionSuccess: {
			component: 'FLXSuccessTickComponent'
		}
	},
	bigFormToStoreMapper: {
		claim_id: 'claim_id',
		new_state: 'new_state'
	}
};
